import { render, staticRenderFns } from "./TodayDamage.vue?vue&type=template&id=01b9509f&scoped=true&"
import script from "./TodayDamage.vue?vue&type=script&lang=js&"
export * from "./TodayDamage.vue?vue&type=script&lang=js&"
import style0 from "./TodayDamage.vue?vue&type=style&index=0&id=01b9509f&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "01b9509f",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VImg } from 'vuetify/lib/components/VImg';
installComponents(component, {VCard,VImg})
